<template>
<div>
  <no-stripe-card-modal ref="noStripeCardModalRef"></no-stripe-card-modal>

  <div class="explain-card limited-width-box">
    <div>
      <i class="material-icons">info</i>
      <div class="flex-grow-1" style="padding-top: 3px;">
        <div class="explain-title">API add-on pricing</div>
        <div class="explain-text mt-3">
          Each month you pay just $10 to get access to POP API and run POP API calls using your POP Credits balance. 1 API call will equal to 1 POP run and will use 2 POP Credits from your balance.<br />
          Access API documentation
          <a href="https://api-docs.pageoptimizer.pro/" target="_blank"
            class="profileAnchorColor--text text-decoration-underline">here</a>.
        </div>
      </div>
    </div>
  </div>
  <div class="mt-10">
    <div class="explain-title">API add-on pricing</div>    
    
    <div class="price-packages mt-5">
      <div class="mt-5 white-common-box pa-5" style="min-width: 280px;">
        <div class="price-label mt-5">$10/month</div>
        <div class="flex-grow-1">
          <div class="mt-7 buy-this-package font-weight-bold">Best for individual site owners</div>
          <div class="mt-7 buy-this-package">
            Buy this package for $10 per month and run POP API calls using your POP Credits balance.
          </div>

          <ul class="mt-10">
            <li v-for="(item, idx) in featuresList" :key="idx" class="mt-1">
              <span>{{ item.text }}</span>
            </li>
          </ul>
        </div>

        <div class="mt-7">
          <v-btn block rounded
            :color="hasLiveAddOn ? 'green7Color' : 'profileAnchorColor'"
            :disabled="checkingPaymentSource"
            :loading="checkingPaymentSource"
            class="text-none whiteColor--text"
            @click="purchaseAction">
            <template v-if="hasLiveAddOn">
              <span class="material-icons">check</span>
              <span>Your current package</span>
            </template>
            <template v-else>
              <span>Buy package</span>
            </template>
          </v-btn>
        </div>

        <div class="mt-5 text-center" v-if="hasLiveAddOn">
          <a class="cancel-btn" @click="() => { showCancelConfirmationModal = true; }">
            Cancel your add-on subscription
          </a>
        </div>

        <div class="mt-5 grayColor--text" v-if="activeAddOnPurchase && activeAddOnPurchase.cancelledOn">
          You cancelled on {{ toLocalDateTimeString(activeAddOnPurchase.cancelledOn) }}.
          Your API access continues until the end of the period you already paid for.
          Buying the package again starts a new $10/month subscription today.
        </div>

      </div>
    </div>
  </div>

  <div class="modal" :class="{'is-active': showCheckoutModal}">
    <div class="modal-background"></div>
    <div class="modal-content" style="width: 900px; max-width: 95vw;">
      <div class="box modal-container" style="overflow: hidden; padding: 0;">
        <div class="checkout-modal">
          <div class="d-flex pad25">
            <div class="modal-title">Checkout</div>
          </div>
          <div class="pad25 main-part">
            <div class="card-part">
              <div class="sub-title mb-5" style="min-height: 30px;">Card details</div>
              <div v-if="preferredCard" class="preferred-card-info">
               <div>
                <template v-if="preferredCard.brand == 'visa'">
                  <img src="/static/visa.png" width="40px" />
                </template>
                <template v-else-if="preferredCard.brand == 'mastercard'">
                  <img src="/static/mastercard.png" width="40px" />
                </template>
                <template v-else>
                  {{ preferredCard.brand }}
                </template>
               </div>
               <div class="flex-grow-1 card-text">
                ending in {{ preferredCard.last4 || '' }}
               </div>
               <div>
                <a @click="onUseDifferentCard">Edit credit card</a>
               </div>
              </div>
            </div>
            <div class="summary-part">
              <div class="d-flex align-center mb-5" style="min-height: 30px;">
                <div class="sub-title">
                  Summary
                </div>
                <!-- <div class="flex-grow-1 text-right">
                  <template v-if="showApplyCouponBox">
                    <div class="promo-input-in-popup">
                      <input type="text" placeholder="coupon code" v-model="promoCode">
                      <a class="coupon-apply-btn" @click="applyCoupon">
                        Apply
                      </a>
                    </div>
                  </template>
                  <template v-else>
                    <a @click="showApplyCouponBox = true;" class="show-apply-coupon-button">
                      <span class="material-icons-outlined">add</span>
                      Apply coupon code
                    </a>
                  </template>
                </div> -->
              </div>
              <!-- <p v-if="serviceCouponsMessage && serviceCouponsValid" class="help has-text-success">{{ serviceCouponsMessage }}</p>
              <p v-if="serviceCouponsMessage && !serviceCouponsValid" class="help has-text-danger">{{ serviceCouponsMessage }}</p> -->
              <div class="summary-box pb-5">
                <div class="d-flex align-center">
                  <div class="flex-grow-1">
                    <div>Product</div>
                    <div class="font-weight-bold" v-html="'Pageoptimzier API add-on package'">
                    </div>
                  </div>
                  <div class="nowrap">
                    $ {{ credits }}
                  </div>
                </div>
                
                <div class="mt-5 pt-10 top-border">
                  <div class="d-flex align-start">
                    <v-checkbox hide-details="auto" class="mt-0 pt-0" v-model="agreedTermsAndService"></v-checkbox>
                    <span>
                      By accessing or calling the API, you agree to abide by all the PageOptimizer Pro
                      <a href="https://www.pageoptimizer.pro/terms-of-service" target="_blank" class="terms-of-service-link">Terms of Service.</a>
                    </span>
                  </div>
                  <div class="buttons-area mt-5">
                    <v-btn rounded
                      :disabled="!agreedTermsAndService"
                      color="profileAnchorColor"
                      class="button-with-icon whiteColor--text text-none"
                      @click="() => {
                        confirmedUseExistingPayment = true;
                        showCheckoutModal = false;
                        submit();
                      }">
                      <span>Subscribe</span>
                    </v-btn>
                    <a class="cancel-link" @click="showCheckoutModal = false;">
                      Cancel
                    </a>
                  </div>
                </div>
                <div class="mt-5">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="custom-modal-close-btn" aria-label="close" @click="showCheckoutModal = false"><i class="material-icons">close</i></button>
    </div>
  </div>

  <div class="modal" :class="{'is-active': showPurchaseCompleteModal}">
    <div class="modal-background" @click.stop="showPurchaseCompleteModal = false"></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="modal-content-root">
          <p class="title-font is-size-4 mainColor--text">Purchase Complete</p>
          <p class="subtitle-font mainColor--text">
            Successfully purchased the add-on package.
          </p>
          <div class="d-flex justify-end gap10">
            <v-btn rounded color="profileAnchorColor" class="button-with-icon whiteColor--text text-none"
              @click.stop="() => {
                showPurchaseCompleteModal = false;
                $router.push({
                  path: `/useraccount/${user.id}`,
                  query: {
                    mainTab: `manage-pop-api-key`
                  }
                })
              }">
              <span>Go to API key management</span>
            </v-btn>
            <v-btn rounded color="grayColor" class="button-with-icon mainColor--text text-none"
              @click.stop="() => {
                showPurchaseCompleteModal = false;
              }">
              <span>Close</span>
            </v-btn>
          </div>
        </div>
      </div>
      <button
        class="custom-modal-close-btn"
        aria-label="close"
        @click="() => (showPurchaseCompleteModal = false)">
        <i class="material-icons">close</i>
      </button>
    </div>
  </div>

  <div class="modal" :class="{'is-active': showCancelConfirmationModal}">
    <div class="modal-background" @click.stop="showCancelConfirmationModal = false"></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="modal-content-root">
          <p class="title-font is-size-4 mainColor--text">Cancel confirmation</p>
          <p class="subtitle-font mainColor--text">
            Do you want to cancel API add-on package?            
          </p>
          <div class="d-flex justify-end gap10">
            <v-btn rounded color="profileAnchorColor" class="button-with-icon whiteColor--text text-none"
              @click.stop="() => {
                showCancelConfirmationModal = false;
                cancelAddonAction()
              }">
              <span>Yes</span>
            </v-btn>
            <v-btn rounded color="grayColor" class="button-with-icon mainColor--text text-none"
              @click.stop="() => {
                showCancelConfirmationModal = false;
              }">
              <span>Close</span>
            </v-btn>
          </div>
        </div>
      </div>
      <button
        class="custom-modal-close-btn"
        aria-label="close"
        @click="() => (showCancelConfirmationModal = false)">
        <i class="material-icons">close</i>
      </button>
    </div>
  </div>

  <div class="modal" :class="{'is-active': showCancelledAddonSubscriptionModal}">
    <div class="modal-background" @click.stop="showCancelledAddonSubscriptionModal = false"></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="modal-content-root">
          <p class="title-font is-size-4 mainColor--text text-center">Subscription cancelled</p>
          <p class="subtitle-font mainColor--text text-center">
            Your API add-on package cancellation has been processed successfully.
          </p>
          <div class="d-flex justify-end gap10">
            <v-btn rounded color="profileAnchorColor" class="button-with-icon whiteColor--text text-none"
              @click.stop="() => {
                showCancelledAddonSubscriptionModal = false;
              }">
              <span>Ok</span>
            </v-btn>
          </div>
        </div>
      </div>
      <button
        class="custom-modal-close-btn"
        aria-label="close"
        @click="() => (showCancelledAddonSubscriptionModal = false)">
        <i class="material-icons">close</i>
      </button>
    </div>
  </div>

  


  <div class="modal" :class="{'is-active': showErrorModal}">
    <div class="modal-background" @click.stop="showErrorModal = false"></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="modal-content-root">
          <p class="title">Purchase Failed</p>
          <p class="subtitle">{{ errorMsg }}</p>
          <div class="text-right">
            <v-btn rounded color="profileAnchorColor" class="button-with-icon mainColor--text text-none"
              @click="showErrorModal = false">
              <span>Ok</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <button class="modal-close is-large" aria-label="close" @click.stop="showErrorModal = false"></button>
  </div>

</div>
</template>

<script>
import NoStripeCardModal from "@/components/NoStripeCardModal.vue";
import {  segmentTrack } from '@/utils'
import servicePackages from '@/components/service_package_constants'
import { toLocalDateTimeString } from '@/utils'

// Shown for every purchase failure that carries no usable reason: a transport error, an
// empty backend message or an unexpected status. Never echo transport or provider details.
const GENERIC_PURCHASE_ERROR = 'The purchase could not be completed. Please try again or contact support.'

export default {
  components: {
    NoStripeCardModal
  },
  data () {
    return {
      agreedTermsAndService: false,
      showCheckoutModal: false,
      preferredCard: '',
      // submit() gates on user.hasPaymentSource, which a separate request fills in after
      // mount. Until it has answered the Buy button stays disabled, otherwise a card holder
      // would be sent to the "no card added" modal without any request leaving the browser.
      checkingPaymentSource: true,
      confirmedUseExistingPayment: false,
      promoCode: '',

      errorMsg: '',
      showErrorModal: false,

      featuresList: [
        {
          text: 'Access to POP API for $10/mo',
        },
        {
          text: 'Run API through your plan credits',
        },
        {
          text: '1 API call equals 1 POP run',
        },
      ],

      showPurchaseCompleteModal: false,
      showCancelConfirmationModal: false,
      showCancelledAddonSubscriptionModal: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    activeAddOnPurchase () {
      return this.user.activeAddOnPurchase;

    },
    hasLiveAddOn () {
      // Attached and not cancelled. A cancelled add-on stays attached until the paid period
      // ends (the daily sync detaches it); in that window the package can be bought again.
      return !!(this.activeAddOnPurchase && !this.activeAddOnPurchase.cancelledOn)
    },
    addOnServicePackage() {
      return servicePackages['ADD_ON_PKG_A']
    },
    selectedServicePkg() {
      if (this.addOnServicePackage) {
        return this.addOnServicePackage.code
      } else {
        return ''
      }
    },
    serviceDescription() {
      return this.addOnServicePackage ? this.addOnServicePackage.description : '';
    },
    credits() {
      return this.addOnServicePackage ? this.addOnServicePackage.price : 0;
    }
  },
  methods: {
    toLocalDateTimeString (d) {
      return toLocalDateTimeString(d)
    },
    loadUser () {
      return this.$store.dispatch('loadUser')
              .then((response) => {
                this.$store.commit('setUser', response.data.user)
                this.$store.dispatch('loadUserHasPaymentSources').then(
                  response => {
                    if (response.data && response.data.status === "SUCCESS") {
                      this.$store.commit('setUserHasPaymentSources', response.data.hasPaymentSource);
                    }
                  }
                )
              })
    },
    checkPaymentSource () {
      this.checkingPaymentSource = true
      return this.$store.dispatch('loadUserHasPaymentSources')
        .then((response) => {
          if (response.data && response.data.status === 'SUCCESS') {
            this.$store.commit('setUserHasPaymentSources', response.data.hasPaymentSource)
            if (response.data.hasPaymentSource) {
              return this.$store.dispatch('fetchPaymentSources').then((response) => {
                if (response.data.status == 'SUCCESS') {
                  this.preferredCard = response.data.cards.find(card => card.preferred)
                } else {
                  console.log('error fetching cards')
                }
              })
            }
          }
        })
        .catch((err) => {
          console.log('error checking payment source', err)
        })
        .finally(() => {
          this.checkingPaymentSource = false
        })
    },
    purchaseAction () {
      if (this.checkingPaymentSource || this.hasLiveAddOn) {
        return;
      }
      this.showCheckoutModal = true;
    },
    trackPurchase () {
      segmentTrack('purchase', {
        paymentService: 'stripe',
        email: this.user.email,
        userID: this.user.id,
        servicePackage: this.selectedServicePkg,
        promoCode: this.promoCode.trim()
      })
    },
    confirmCardPaymentAndActivate (clientSecret) {
      return window.stripe.confirmCardPayment(clientSecret).then((result) => {
        if (result.error) {
          this.errorMsg = result.error.message
          this.showErrorModal = true
          return
        }
        this.showPurchaseCompleteModal = true
        this.trackPurchase()
        return this.waitForAddOnActivation()
      })
    },
    waitForAddOnActivation (attempts = 10, intervalMs = 3000) {
      // The add-on is attached to the account by Stripe's paid-invoice webhook, which can
      // lag the card confirmation by a few seconds. Refresh until it shows up or we give up.
      const refresh = () => this.$store.dispatch('loadUser').then((response) => {
        if (response.data && response.data.status === 'SUCCESS') {
          this.$store.commit('setUser', response.data.user)
        }
      })
      const poll = (left) => refresh().then(() => {
        if (this.activeAddOnPurchase || left <= 0) {
          return
        }
        return new Promise(resolve => setTimeout(resolve, intervalMs)).then(() => poll(left - 1))
      })
      return poll(attempts).catch((err) => {
        // The payment went through; a failed refresh must not be reported as a failed purchase.
        console.log('error refreshing user after purchase', err)
      })
    },
    submit() {
      const order = {
        description: this.serviceDescription,
        servicePackage: this.selectedServicePkg,
        amount: this.credits
      }
      if (this.credits < 10) {
        return
      }
      let promise
      if (this.user.hasPaymentSource && !this.useDifferentCard) {
        if (!this.confirmedUseExistingPayment) {
          this.showConfirmUseExistingPayment = true
          return;
        }
        this.$store.commit('showLoading')
        promise = this.$store.dispatch('createPurchase', {
          userId: this.user.id,
          servicePackage: this.selectedServicePkg,
          stripeToken: '',
          paymentService: 'stripe',
          description: order.description,
          promoCode: this.promoCode.trim(),
          // The cancelled add-on still attached to the account. The backend checks it against
          // Stripe and only creates a new subscription when that one is really gone.
          oldPurchaseId: this.activeAddOnPurchase ? this.activeAddOnPurchase.id : undefined,
        })
      } else {
        this.$refs.noStripeCardModalRef.showModalAction();
        return;
      }
      promise.then((response) => {
        const data = response.data || {}
        if (data.status === 'SUCCESS') {
          this.showPurchaseCompleteModal = true
          if (data.user) {
            this.$store.commit('setUser', data.user)
          }
          this.trackPurchase()
          return
        }
        if (data.status === 'FAILURE' && data.clientSecret) {
          // 3D Secure: Stripe takes over in its own dialog, so drop our overlay first.
          this.$store.commit('hideLoading')
          return this.confirmCardPaymentAndActivate(data.clientSecret)
        }
        // A refusal without a reason, or any status we do not know, still gets a modal.
        this.errorMsg = data.msg || GENERIC_PURCHASE_ERROR
        this.showErrorModal = true
      })
        .catch((err) => {
          console.log('purchase error', err)
          this.errorMsg = GENERIC_PURCHASE_ERROR
          this.showErrorModal = true
        })
        .finally(() => {
          setTimeout(() => {
            this.loadUser().finally(() => {
              this.$store.commit('hideLoading')
            })            
          }, 1000);
          
        })
    },
    onUseDifferentCard () {
      this.$router.push(`/useraccount/${this.user.id}?mainTab=billing-and-payments&subTab=credit-cards`)
    },
    cancelAddonAction () {
      this.$store.commit('showLoading')
      this.$store.dispatch("cancelSubscription", {
        purchaseId: this.activeAddOnPurchase.id,
      }).then(response => {
        if (response.data && response.data.status === "SUCCESS") {
          if (response.data.user) {
            this.$store.commit("setUser", response.data.user);
          }
          this.loadUser().finally(() => {
            this.showCancelledAddonSubscriptionModal = true;
          })

        } else {
          this.$notify({
            group: 'info', type: 'error', duration: 5000,
            text: 'Unable to cancel at this time. If you have already cancelled your PayPal payment,  your POP subscription has been cancelled.\nYour dashboard will update in the next 24 hours. If you have not cancelled in PayPal and are still receiving this error message please contact support.',
          })
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading');
      });
    }
  },
  mounted () {
    this.$store.commit('showLoading')
    return this.$store.dispatch('loadUser').then((response) => {
        if (response.data && response.data.status === 'SUCCESS') {
            this.$store.commit('setUser', response.data.user)
            this.checkPaymentSource()
        } else {
            this.checkingPaymentSource = false
        }
      }).catch((err) => {
        console.log('error loading user', err)
        this.checkingPaymentSource = false
      }).finally(() => this.$store.commit('hideLoading'))
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/ui-for-api-style.scss";
</style>